import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import config from 'constants/config'
import { agentHubOrSubBrandConfig } from 'agentHub/constants'
import TextLink from 'LuxKit/TextLink'
import type { PageBannerCarouselItem } from 'LuxKit/Banners/types'

function useAgentHubBannerItems(): Array<PageBannerCarouselItem> {
  return useMemo(() => {
    if (!config.agentHub.isEnabled) return []

    return [{
      id: 'agent-hub-support',
      kind: 'promotional-primary',
      children: <FormattedMessage
        id="dWKLR3ckHKyE3edGxGcI"
        defaultMessage="Need help? Email <emailLink>{supportEmail}</emailLink>"
        description="Agent hub support email banner in the page header in the site header"
        values={{
          supportEmail: agentHubOrSubBrandConfig.supportEmail,
          emailLink: (chunks) => <TextLink href={`mailto:${agentHubOrSubBrandConfig.supportEmail}`}>{chunks}</TextLink>,
        }}
      />,
    }]
  }, [])
}

export default useAgentHubBannerItems
